import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';

import { ServiceView } from '@estee/elc-service';
import { LOYALTY_EARN_POINTS } from '@estee/elc-service-view-names';
import { IPosition } from '~views/components/interfaces';
import { ILoyaltyEarnPoints } from './ILoyaltyEarnPoints';
import { serviceName } from '~setup/packageInfo';
import { addFullBleed, classes } from '~utils/Classes';
import { dashboardSections as ds } from '~views/dashboard/sections';

const LoyaltyEarnPointsWrapper = styled.div`
    grid-area: ${ds.earnPoints};
    min-width: 0;
`;

const LoyaltyEarnPointsInnerWrapper = styled.div``;

export interface ILoyaltyEarnPointsData {
    text: string;
}

export interface ILoyaltyEarnPointsContent {
    earnPointsHeader: ILoyaltyEarnPointsData;
    earnPointsSubHeader: ILoyaltyEarnPointsData;
    earnPointInfo: ILoyaltyEarnPoints[];
}

export interface ILoyaltyEarnPointsView extends IPosition {
    earnPoints: ILoyaltyEarnPointsContent;
}

export const TEST_ID_EARNPOINTS = 'loyalty-dashboard-earn-points';
const earnPointsClass = classes('loyalty-dashboard-earn-points-info');
const loyaltyEarnPointsInnerWrapper = classes('loyalty-dashboard-earn-points-info-inner-wrapper');

export const LoyaltyEarnPoints = observer(function LoyaltyEarnPoints(
    section: ILoyaltyEarnPointsView
) {
    const { position } = section;
    const classNames = `${earnPointsClass} ${addFullBleed(position)}`;

    return (
        <LoyaltyEarnPointsWrapper className={classNames} data-test-id={TEST_ID_EARNPOINTS}>
            <LoyaltyEarnPointsInnerWrapper className={loyaltyEarnPointsInnerWrapper}>
                <ServiceView
                    name={LOYALTY_EARN_POINTS}
                    serviceName={serviceName}
                    config={section}
                />
            </LoyaltyEarnPointsInnerWrapper>
        </LoyaltyEarnPointsWrapper>
    );
});
